export default __webpack_public_path__ + "static/media/14d824a2-2a5c-4692-8e30-74f6e177b675.f7a280dd.ttf";